// @ts-nocheck
import React, { createRef } from "react";
import { Modal, Input } from "antd";
import BaseComponent from "../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../sections/taskInfoSections";
import ProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import InputLabel from "../../../../base/basicComponents/inputLabel";
import Buttons from "../../../../base/basicComponents/button";
import { ModalWithComponent } from "../../../../base/basicComponents/modal";
import { actions, shareTaskMassage } from "../../../publicDictionaryValues";
import changeMainTaskService from "../../../../service/changeMainTask/changeMainTaskService";
import ReviseChangeMainTask from "../../../sections/sharedTaskSections/reviseChangeMainTask";
import NormalModel from "../../../../base/basicComponents//modal/index";
import styles from "../../procedureFileProcess/style/index.module.scss";
import reviseShareService from "../../../../service/shareTask/reviseShareService";
import appService from "../../../../service/app";
import LostPermissionModal from "../../../sections/lostPermissionModal";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";
import { disableInteraction } from "utils/index";

const procedureReturnAddFileRef = createRef();
const procedureFileRef = createRef();
const reviseChangeMainTaskTaskRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();

export default class ReviseChangeMainTaskProcess extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      pageState: this.handleReviseChangeMainTaskPageState(),
      modalState: this.handleReviseChangeMainTaskModalState(),
      isApproveComfirmOpen: false,
      confirmModalText: "",
      handleApproveComfirm: () => {
        //this is a empty function
      },
      returnOrRejectModalTitle: "",
      isReturnOrRejectModalOpen: false,
      returnOrRejectInputStatus: "",
      returnOrRejectInputValue: "",
      noPermission: false,
    };
    // @ts-ignore
    this.para = null;
    // @ts-ignore
    this.isTableBorderError = false;
    // @ts-ignore
    this.params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };
  }

  handleReviseChangeMainTaskPageState = () => {
    const { rejectReason, rejectStatus } = this.props.pageProps;

    return {
      rejectReason,
      rejectStatus,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      isTableBorderError: false,
      isChange: false,
    };
  };

  handleReviseChangeMainTaskModalState = () => {
    return {
      modalTitle: "",
      modalLabel: "",
      okText: "",
      cancelText: "",
      closable: false,
      isOkBtnDisabled: false,
      isCancelBtnDisabled: false,
      maskClosable: false,
      isModalWithComponentOpen: false,
      isShowSelect: false,
      rowIndex: 0,
      fileIds: [],
      fileNames: [],
      modalWidth: 520,
    };
  };

  reviseChangMainTaskCancelConfirm = () => {
    this.setState({
      isApproveComfirmOpen: false,
    });
    // @ts-ignore
    reviseChangeMainTaskTaskRef.current.resetReviseData();
    this.props.closePage();
  };

  handleChangMainTaskCancel = () => {
    this.setState({
      isApproveComfirmOpen: true,
      confirmModalText: "Are you sure to quit without saving?",
      handleApproveComfirm: this.reviseChangMainTaskCancelConfirm,
    });
  };

  transformChangMainTaskData = (data: any) => {
    if (data === undefined) {
      return null;
    }
    const outputData = data.map((obj: any) => {
      if (obj.hasOwnProperty("isDeleted")) {
        obj.isDel = obj.isDeleted;
        delete obj.isDeleted;
      }
      return obj;
    });

    return outputData;
  };

  handleChangMainTaskSubmitPara = (actionID: any, actionName: any) => {
    return {
      tasks: this.transformChangMainTaskData(
        JSON.parse(
          // @ts-ignore
          JSON.stringify(reviseChangeMainTaskTaskRef.current.state.reviseData)
        )
      ),
      flowCategoryID: this.props.params.FlowCategoryID,
      procedureProcessId: this.props.shareTaskData.procedureProcessID,
      workflowProcessInstanceId: this.props.params.WorkflowProcessInstanceId,
      rejectReason: this.state.pageState.rejectReason,
      procedureStepID: this.props.params.ProcedureStepID,
      shareTaskProcedureStepId: this.props.shareTaskData.shareTaskProcedureStepID,
      // @ts-ignore
      reason: reviseChangeMainTaskTaskRef.current.state.reasonValue,
      actionName: actionName,
      actionID: actionID,
    };
  };

  approveSuccess = () => {
    this.props._hideLoading();
    this._alertSuccess("Revise Successful");
    this.props.closePage();
  };

  approveFailed = () => {
    this.props._hideLoading();
    this._alertError("Revise Failed");
  };

  checkSubmitOnError = () => {
    this._alertError("Submit Failed");
  };

  checkSubmitOnSuccess = (result: any) => {
    let currentData = JSON.parse(
      // @ts-ignore
      JSON.stringify(reviseChangeMainTaskTaskRef.current.state.reviseData)
    );

    if (!result.result) {
      const errorMsg =
        "There are some tasks that do not meet the conditions for adding to or removing from the sharing relationship. Please check the specific reasons in the task list.";
      this._alertError(errorMsg, 6);
      const responseData = result.resultList;
      for (let index = 0; index < currentData.length; index++) {
        const responseIndex = responseData.findIndex(
          (x: any) => x.taskId === currentData[index].taskId && !x.checkResult
        );
        if (responseIndex > -1) {
          currentData[index] = {
            ...currentData[index],
            hasError: true,
            // @ts-ignore
            errorMessage: shareTaskMassage[responseData[responseIndex].msgCode],
          };
        } else {
          currentData[index] = {
            ...currentData[index],
            hasError: false,
            errorMessage: "",
          };
        }
      }
      // @ts-ignore
      reviseChangeMainTaskTaskRef.current.updateReviseData(currentData);
    } else {
      const data = currentData.map((item: any) => {
        if (item.hasError === true) {
          return {
            ...item,
            hasError: false,
            errorMessage: "",
          };
        }

        return item;
      });
      // @ts-ignore
      reviseChangeMainTaskTaskRef.current.updateReviseData(data);
      // @ts-ignore
      if (reviseChangeMainTaskTaskRef.current.dataHasChange()) {
        this.setState({
          isApproveComfirmOpen: true,
          confirmModalText: "Are you sure to submit?",
          handleApproveComfirm: this.handleApproveComfirm,
        });
      } else {
        this.setState({
          isApproveComfirmOpen: true,
          confirmModalText:
            "No changes made! Are you sure to resubmit this request without any changes?",
          handleApproveComfirm: this.handleApproveComfirm,
        });
      }
    }
  };

  handleApproveComfirm = () => {
    this.props._showLoading();
    this.setState({
      isApproveComfirmOpen: false,
    });
    const para = this.handleChangMainTaskSubmitPara(actions.revise, "Revise");
    // @ts-ignore
    const deleteList = reviseChangeMainTaskTaskRef.current.getDeleteData();
    if (deleteList.length > 0) {
      for (let item of deleteList) {
        const para = {
          procedureTaskId: item.procedureTaskId,
          shareTaskProcedureStepId: this.props.shareTaskData.shareTaskProcedureStepID,
        };
        reviseShareService.delTaskRowInfo(
          para,
          () => {
            // this is an empty function
          },
          () => {
            // this is an empty function
          }
        );
      }
    }

    changeMainTaskService.manageShareTaskTriggerAction(
      para,
      this.approveSuccess,
      this.approveFailed
    );
  };

  handleChangeMainSubmitClick = () => {
    // @ts-ignore
    if (reviseChangeMainTaskTaskRef.current.state.reasonValue.trim() === "") {
      // @ts-ignore
      reviseChangeMainTaskTaskRef.current.updateReasonInputErrorStatus();
      return;
    }
    const currentData = JSON.parse(
      // @ts-ignore
      JSON.stringify(reviseChangeMainTaskTaskRef.current.state.reviseData)
    );
    let oldMainTask = currentData.find((item: any) => item.isOldMainTask === true);
    if (currentData.length === 2 && oldMainTask !== undefined && oldMainTask.isDeleted) {
      this._alertError(
        "Please note that the Change Main Task process cannot be initiated when there is no active shared task.",
        6
      );
      return;
    }

    let transformChangMainTaskData = this.transformChangMainTaskData(
      JSON.parse(
        // @ts-ignore
        JSON.stringify(reviseChangeMainTaskTaskRef.current.state.reviseData)
      )
    );
    let transformNewMainTask = transformChangMainTaskData.find(
      (item: any) => item.isNewMainTask === true
    );
    let transformOldMainTask = transformChangMainTaskData.find(
      (item: any) => item.isOldMainTask === true
    );
    if (transformNewMainTask === undefined || transformNewMainTask === null) {
      const result = {
        result: true,
      };
      this.checkSubmitOnSuccess(result);
      return;
    }
    disableInteraction();
    const checkPara = {
      procedureId: this.props.params.ProcedureID,
      procedureStepId: this.props.params.ProcedureStepID,
      oldMainTask: transformOldMainTask,
      newMainTask: transformNewMainTask,
      taskList: currentData,
    };
    changeMainTaskService.checkSubmit(
      checkPara,
      this.checkSubmitOnSuccess,
      this.checkSubmitOnError
    );
  };

  _checkStepPermissionSuccess = (result: any) => {
    this.props._hideLoading();
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.setState({
      noPermission,
    });
    if (noPermission) return;
    this.handleReviseSubmitClick();
  };

  checkStepPermission = () => {
    this.props._showLoading();
    const param = {
      taskID: this.props.params.ProcedureTaskId,
      procedureID: this.props.params.ProcedureID,
      procedureStepID: this.props.params.ProcedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(param, this._checkStepPermissionSuccess, (response: any) =>
      this._alertError(response.message)
    );
  };

  handleReviseSubmitClick = () => {
    this.handleChangeMainSubmitClick();
  };

  handleApproveComfirmCancel = () => {
    this.setState({
      isApproveComfirmOpen: false,
    });
  };

  handleChangeMainTaskPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.props.pageProps;

    return (
      <PageHeader
        title="Revise Main Task"
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status={procedureStepStatus}
      />
    );
  };

  handleChangeMainTaskTaskInformation = () => {
    const { taskInfoData } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        testid="task-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo],
            StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
          );
        }}
      />
    );
  };

  handleChangeMainTaskTaskProcedureFileSection = () => {
    const { serverPathValue, savedInRadioValue, fileTableData, jbProcedureSavedIn } = this.props;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlyProcedureFileSection
            procedureFileRef={procedureFileRef}
            clientServerPath={serverPathValue}
            savedInRadioValue={savedInRadioValue}
            procedureFileData={fileTableData !== undefined ? fileTableData : []}
            jbProcedureSavedIn={jbProcedureSavedIn}
          />
        }
        testid="procedure-file-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureFileData,
            this.setError,
            [StepBusinessType.procedureFile]
          );
        }}
      />
    );
  };

  handleChangeMainTaskTaskSupportingFileSection = () => {
    const { supportingTableData } = this.props;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlySupportingFileSection
            supportingFileRef={supportingFileRef}
            supportingFileTableRef={supportingFileTableRef}
            supportingFileData={supportingTableData}
          />
        }
        testid="supporting-file-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setSupportingFileData,
            this.setError,
            [StepBusinessType.supportingFile]
          );
        }}
      />
    );
  };

  handleChangeMainTaskTaskProcedureInformationSection = () => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            isShowActions={false}
            noteDisabled={true}
            ppoList={ppoList}
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            submitData={procedureInfoData}
            title="Procedure Information"
          />
        }
        testid="procedure-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureInfoData,
            this.setError,
            [
              StepBusinessType.procedureOwner,
              StepBusinessType.pmpExcluded,
              StepBusinessType.primaryProcedureOwner,
            ]
          );
        }}
      />
    );
  };

  handleReviseChangeMainTaskSection = () => {
    const { shareTaskData } = this.props;

    return (
      <ProcedureBlock
        className={styles.approveProcedureFile}
        child={
          // @ts-ignore
          <ReviseChangeMainTask
            ref={reviseChangeMainTaskTaskRef}
            procedureTaskId={this.props.params.ProcedureTaskId}
            shareTaskData={shareTaskData}
            procedureStepId={this.props.params.ProcedureStepID}
          />
        }
        testid="change-main-task-block-arrow"
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleReviseChangeMainButton = () => {
    const { isCancelDisabled, isSubmitDisabled } = this.state.pageState;

    return (
      <div className={styles.actionBtns}>
        <div className={styles.normalBtns}>
          <Buttons
            testid="revise-change-main-task-cancel-btn"
            color="grey"
            size="middle"
            onClick={this.handleChangMainTaskCancel}
            disabled={isCancelDisabled}
            btnClassName={styles.approveActionBtn}
          >
            Cancel
          </Buttons>
          <Buttons
            testid="revise-change-main-task-submit-btn"
            color="blue"
            size="middle"
            onClick={this.checkStepPermission}
            disabled={isSubmitDisabled}
            btnClassName={styles.approveActionSubmitBtn}
          >
            Submit for Approval
          </Buttons>
        </div>
      </div>
    );
  };

  handleReviseChangeMainModalWithComponent = () => {
    const { procedureReplaceFileRef } = this.props.pageProps;
    const {
      modalTitle,
      modalLabel,
      okText,
      cancelText,
      closable,
      isOkBtnDisabled,
      isCancelBtnDisabled,
      maskClosable,
      isModalWithComponentOpen,
      rowIndex,
      fileIds,
      fileNames,
      modalWidth,
      handleOk,
      handleCancel,
    } = this.state.modalState;

    return (
      // @ts-ignore
      <ModalWithComponent
        testid="revise-change-main-task-modal"
        isModalOpen={isModalWithComponentOpen}
        closable={closable}
        okText={okText}
        cancelText={cancelText}
        title={modalTitle}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isOkDisabled={isOkBtnDisabled}
        isCancelDisabled={isCancelBtnDisabled}
        maskClosable={maskClosable}
        label={modalLabel}
        fileUploadRef={procedureReplaceFileRef}
        fileUploadInputRef={procedureReturnAddFileRef}
        rowindex={rowIndex}
        fileIds={fileIds}
        fileNames={fileNames}
        hideLoading={(this as any)._hideModalBtnsDisabled}
        openLoading={(this as any)._openModalBtnsDisabled}
        isLoading={isOkBtnDisabled}
        modalWidth={modalWidth}
      />
    );
  };

  handleReviseChangeMainTaskModal = () => {
    return (
      // @ts-ignore
      <Modal
        title={
          <InputLabel
            text={this.state.returnOrRejectModalTitle}
            required={true}
            className={styles.modalText}
          />
        }
        open={this.state.isReturnOrRejectModalOpen}
        okText="Submit"
        onOk={(this as any).handleReturnOrRejectOk}
        onCancel={(this as any).handleReturnOrRejectCancel}
        maskClosable={false}
      >
        {/* @ts-ignore */}
        <Input.TextArea
          maxLength={1000}
          style={{
            height: 120,
            resize: "none",
          }}
          status={this.state.returnOrRejectInputStatus}
          onChange={(e) => (this as any).returnOrRejectInputOnChange(e.target)}
          value={this.state.returnOrRejectInputValue}
        />
      </Modal>
    );
  };

  handleReviseChangeMainTaskNormalModel = () => {
    return (
      <NormalModel
        okText="Confirm"
        cancelText="Cancel"
        childContent={<p className="fs-16">{this.state.confirmModalText}</p>}
        isModalOpen={this.state.isApproveComfirmOpen}
        handleOk={this.state.handleApproveComfirm}
        handleCancel={this.handleApproveComfirmCancel}
      />
    );
  };

  render() {
    const { procedureStepStatus } = this.props.pageProps;

    return (
      <div className={styles.approveNewPro}>
        {this.handleChangeMainTaskPageHeader()}
        {this.handleChangeMainTaskTaskInformation()}
        {this.handleChangeMainTaskTaskProcedureFileSection()}
        {this.handleChangeMainTaskTaskSupportingFileSection()}
        {this.handleChangeMainTaskTaskProcedureInformationSection()}
        {this.handleReviseChangeMainTaskSection()}
        {procedureStepStatus === "Pending" && this.handleReviseChangeMainButton()}
        {this.handleReviseChangeMainModalWithComponent()}
        {this.handleReviseChangeMainTaskModal()}
        {this.handleReviseChangeMainTaskNormalModel()}
        <LostPermissionModal isModalOpen={this.state.noPermission} />
      </div>
    );
  }
}
